import React, { useEffect, useState } from "react";
import { Header, HeadMetaTags, ItemsGrid } from "../components";
import ReactGA from "react-ga4";
import { useStateContext } from "../contexts/ContextProvider";
import { useLocation, useParams } from "react-router-dom";
import { apiGetAllPublishedRooms } from "../services/apiService";
import { fiveBoroughs, mostPopularCityData } from "../data/citiesData";
import { Link } from "react-router-dom";

const Rooms = () => {
  const { publishedRooms, setPublishedRooms } = useStateContext();
  const [stateSearchError, setStateSearchError] = useState(false);

  const params = useParams();
  const location = useLocation();
  const isTracking =
    process.env.REACT_APP_GA_TRACKING === "true" ? true : false;

  useEffect(() => {
    if (isTracking) {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
      });
    }
    // eslint-disable-next-line
  }, [location]);

  const handleGAEvent = (category, action, label) => {
    if (isTracking) {
      ReactGA.event({
        category,
        action,
        label,
      });
    }
  };

  const cityObject = mostPopularCityData.find((x) => x.slug === params.city);

  const searchParams = new URLSearchParams(location.search);
  const neighborhood = searchParams.get("neighborhood");

  const city = cityObject ? cityObject.city : searchParams.get("city");
  const state = cityObject ? cityObject.state : searchParams.get("state");
  const latitude = cityObject ? cityObject.latitude : searchParams.get("lat");
  const longitude = cityObject
    ? cityObject.longitude
    : searchParams.get("long");
  const searchText = searchParams.get("search");

  const isNYC =
    fiveBoroughs.find((x) => x === city.toLowerCase()) || city === "New York";

  console.log(isNYC);

  const locationPayload = {
    neighborhood,
    city,
    state,
    latitude,
    longitude,
    searchText,
  };

  useEffect(() => {
    setPublishedRooms([]);
    newApiCall();
    // eslint-disable-next-line
  }, [city]);

  const newApiCall = async () => {
    // do not allow state-wide searches
    if (stateOnly()) {
      return;
    }
    const response = await apiGetAllPublishedRooms(locationPayload);
    handleGAEvent(
      "Search",
      "Search City",
      `${(locationPayload.city, locationPayload.state)}`
    );
    if (response.hasError) {
      console.log(response.error.response.statusText);
      return;
    } else {
      setPublishedRooms(response.data);
    }
  };

  const stateOnly = () => {
    if (
      (!locationPayload.neighborhood &&
        !locationPayload.city &&
        !locationPayload.searchText) ||
      (locationPayload.searchText && locationPayload.searchText.length < 3)
    ) {
      setStateSearchError(true);
      return true;
    }
  };
  console.log(city);
  return (
    <>
      <HeadMetaTags
        title={`Rooms for rent in ${
          city.toLowerCase() === "new york"
            ? "NYC"
            : (city ? city[0].toUpperCase() + city.slice(1) : "") +
              (searchText
                ? searchText[0].toUpperCase() + searchText.slice(1)
                : "") +
              (state ? `, ${state.toUpperCase()}` : "")
        }`}
        ogTitle={`${
          (city ? city[0].toUpperCase() + city.slice(1) : "") +
          (searchText
            ? searchText[0].toUpperCase() + searchText.slice(1)
            : "") +
          (state ? `, ${state.toUpperCase()}` : "")
        } | Rooms for rent on Snappily`}
      />
      <section id="header" className="w-screen">
        <Header />
      </section>
      <section id="rooms" className="fixed left-0 right-0 mt-20">
        {!isNYC && (
          <div className="flex justify-center my-2 capitalize">
            Searching:{" "}
            {(city ? city : "") +
              (searchText ? searchText : "") +
              (state ? `, ${state.toUpperCase()}` : "")}
          </div>
        )}
        {isNYC && (
          <div className="flex justify-center mt-5">
            <div className="grid justify-items-center grid-cols-3 mb-5 w-full">
              <Link
                to="/search/new-york"
                className={`cursor-pointer ${
                  city.toLowerCase() === "new york"
                    ? "text-snappily-orange"
                    : "text-blue-500 hover:text-blue-700"
                }`}
              >
                All NYC
              </Link>
              <Link
                to="/rooms?city=manhattan"
                className={` cursor-pointer ${
                  city.toLowerCase() === "manhattan"
                    ? "text-snappily-orange"
                    : "text-blue-500 hover:text-blue-700"
                }`}
              >
                Manhattan
              </Link>
              <Link
                to="/rooms?city=queens"
                className={`cursor-pointer ${
                  city.toLowerCase() === "queens"
                    ? "text-snappily-orange"
                    : "text-blue-500 hover:text-blue-700"
                }`}
              >
                Queens
              </Link>
              <Link
                to="/rooms?city=brooklyn"
                className={`cursor-pointer ${
                  city.toLowerCase() === "brooklyn"
                    ? "text-snappily-orange"
                    : "text-blue-500 hover:text-blue-700"
                }`}
              >
                Brooklyn
              </Link>
              <Link
                to="/rooms?city=bronx"
                className={`cursor-pointer ${
                  city.toLowerCase() === "bronx"
                    ? "text-snappily-orange"
                    : "text-blue-500 hover:text-blue-700"
                }`}
              >
                Bronx
              </Link>
              <Link
                to="/rooms?city=staten%20island"
                className={`cursor-pointer ${
                  city.toLowerCase() === "staten island"
                    ? "text-snappily-orange"
                    : "text-blue-500 hover:text-blue-700"
                }`}
              >
                Staten Island
              </Link>
            </div>
          </div>
        )}
        {publishedRooms.length > 0 ? (
          <div className="">
            <ItemsGrid roomsArray={publishedRooms} />
          </div>
        ) : (
          <div className="flex justify-center mt-20">
            {stateSearchError
              ? "Your search is too broad, please narrow your search and try again."
              : "There are no rooms available in this area."}
          </div>
        )}
      </section>
    </>
  );
};

export default Rooms;
